<cm-inspector-section>
    <ng-container cm-content>
        <cm-value-slot [node]="$node()" [key]="'name'" [label]="'Name'"></cm-value-slot>
        <cm-value-slot [node]="$node()" [key]="'id'" [label]="'ID'" [validate]="$isValidExternalId()"></cm-value-slot>
    </ng-container>
</cm-inspector-section>

<cm-inspector-section>
    <ng-container cm-title> Value </ng-container>
    <ng-container cm-content>
        @if ($curveExport(); as curveExport) {
            <cm-value-slot
                [node]="curveExport"
                [key]="'node'"
                [label]="'Curve'"
                [selectionPossibilities]="$curveExportSelectionPossibilities()"
            ></cm-value-slot>
        }
        @if ($referenceFrameExport(); as referenceFrameExport) {
            <cm-value-slot
                [node]="referenceFrameExport"
                [key]="'node'"
                [label]="'Reference Frame'"
                [selectionPossibilities]="$referenceFrameExportSelectionPossibilities()"
            ></cm-value-slot>
        }
    </ng-container>
</cm-inspector-section>
